module.exports = __webpack_public_path__ + "media/images/info_icon-96d397092da557889afdbd3358cc76bf.png";